const initials = "user/";

export const UPDATE_USER = `${initials}UPDATE_USER`;
export const UPDATE_FILTER = `${initials}UPDATE_FILTER`;
export const UPDATE_REDUCER = `${initials}UPDATE_REDUCER`;